import React, { useState } from 'react';
import { useTheme } from '../context/ThemeContext';
import { BsSunFill, BsMoonStarsFill } from "react-icons/bs";
import './ThemeToggle.css';

function ThemeToggle() {
  const { theme, toggleTheme } = useTheme();
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      className="theme-toggle-floating"
      onClick={toggleTheme}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      title={theme === 'dark' ? 'Switch to Light Mode' : 'Switch to Dark Mode'}
      aria-label="Toggle theme"
    >
      <div className="theme-toggle-icon-wrapper">
        {theme === 'dark' ? (
          <BsSunFill className="theme-toggle-icon theme-toggle-sun" />
        ) : (
          <BsMoonStarsFill className="theme-toggle-icon theme-toggle-moon" />
        )}
      </div>
      {isHovered && (
        <div className="theme-toggle-tooltip">
          {theme === 'dark' ? 'Light Mode' : 'Dark Mode'}
        </div>
      )}
      <div className="theme-toggle-ripple"></div>
    </div>
  );
}

export default ThemeToggle;

